import { render, staticRenderFns } from "./loginNav.vue?vue&type=template&id=436577ca&scoped=true&"
import script from "./loginNav.vue?vue&type=script&lang=js&"
export * from "./loginNav.vue?vue&type=script&lang=js&"
import style0 from "./loginNav.vue?vue&type=style&index=0&id=436577ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436577ca",
  null
  
)

export default component.exports